'use client';

import { c as _c } from "react/compiler-runtime";
import { ExternalLinkTooltip, Field, FieldContent, FieldDescription, FieldError, FieldLabel, Input, InputGroup, InputGroupAddon, InputGroupInput, Spinner } from '@repo/ui/components';
import { cn } from '@repo/ui/lib/utils';
import { ComponentProps, ReactNode } from 'react';
import { useFieldContext } from '../lib/form-context.ts';
import { dedupeErrors } from '../lib/dedupe-errors.ts';
export const FormInput = t0 => {
  const $ = _c(42);
  let description;
  let href;
  let label;
  let props;
  let required;
  let t1;
  let t2;
  let variant;
  if ($[0] !== t0) {
    ({
      description,
      disabled: t1,
      href,
      isPending: t2,
      label,
      required,
      variant,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = description;
    $[2] = href;
    $[3] = label;
    $[4] = props;
    $[5] = required;
    $[6] = t1;
    $[7] = t2;
    $[8] = variant;
  } else {
    description = $[1];
    href = $[2];
    label = $[3];
    props = $[4];
    required = $[5];
    t1 = $[6];
    t2 = $[7];
    variant = $[8];
  }
  const disabled = t1 === undefined ? false : t1;
  const isPending = t2 === undefined ? false : t2;
  const field = useFieldContext();
  let t3;
  if ($[9] !== field.state.meta.errors) {
    t3 = field.state.meta.errors ?? [];
    $[9] = field.state.meta.errors;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t3) {
    t4 = dedupeErrors(t3);
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const errors = t4;
  let t5;
  if ($[13] !== field.name || $[14] !== href || $[15] !== label || $[16] !== required) {
    t5 = label && typeof label === "string" ? <FieldLabel className={cn(required && "required gap-0.5")} htmlFor={field.name}>{label} {href && <ExternalLinkTooltip href={href} />}</FieldLabel> : label;
    $[13] = field.name;
    $[14] = href;
    $[15] = label;
    $[16] = required;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const t6 = isPending || disabled;
  let t7;
  if ($[18] !== field) {
    t7 = e => field.handleChange(e.target.value);
    $[18] = field;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== field.handleBlur || $[21] !== field.name || $[22] !== field.state.value || $[23] !== props || $[24] !== t6 || $[25] !== t7) {
    t8 = <InputGroupInput data-testid={field.name} disabled={t6} id={field.name} onBlur={field.handleBlur} onChange={t7} value={field.state.value} {...props} data-sentry-element="InputGroupInput" data-sentry-source-file="form-input.tsx" />;
    $[20] = field.handleBlur;
    $[21] = field.name;
    $[22] = field.state.value;
    $[23] = props;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== isPending) {
    t9 = isPending && <InputGroupAddon align="inline-end"><Spinner className="text-muted-foreground" /></InputGroupAddon>;
    $[27] = isPending;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] !== t8 || $[30] !== t9 || $[31] !== variant) {
    t10 = <InputGroup variant={variant} data-sentry-element="InputGroup" data-sentry-source-file="form-input.tsx">{t8}{t9}</InputGroup>;
    $[29] = t8;
    $[30] = t9;
    $[31] = variant;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== description) {
    t11 = description && typeof description === "string" ? <FieldDescription>{description}</FieldDescription> : description;
    $[33] = description;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== errors) {
    t12 = <FieldError className="text-sm" errors={errors} data-sentry-element="FieldError" data-sentry-source-file="form-input.tsx" />;
    $[35] = errors;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== t10 || $[38] !== t11 || $[39] !== t12 || $[40] !== t5) {
    t13 = <Field className="group gap-1" data-sentry-element="Field" data-sentry-component="FormInput" data-sentry-source-file="form-input.tsx"><FieldContent data-sentry-element="FieldContent" data-sentry-source-file="form-input.tsx">{t5}{t10}{t11}{t12}</FieldContent></Field>;
    $[37] = t10;
    $[38] = t11;
    $[39] = t12;
    $[40] = t5;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  return t13;
};